module.exports = __webpack_public_path__ + "static/media/meter_3.33ba45e1.png";